import React, { useState } from 'react';
import LoginForm from '../../../components/ui/forms/login';
import { login, authenticate } from '../../../services/auth';
import { message, notification } from 'antd';
import { useDispatch } from 'react-redux';

const Login = ({ history }) => {
  const [values, setValues] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { email, password } = values;

  const dispatch = useDispatch();

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await login({
        email: email,
        password: password,
      });
      if (data) {
        //Save user and token to LocalSTorage
        authenticate(data);
        //Save user and token to redux
        dispatch({
          type: 'LOGGED_IN_USER',
          payload: data.token,
        });
        history.push('user/dashboard');
        window.location.reload();
      }
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 400) {
        const errorMessage = 'Email ou senha incorretos';
        setError(errorMessage);
        notification.error({
          message: 'Erro de Login',
          description: errorMessage,
          duration: 4,
          placement: 'topRight',
          style: { zIndex: 1400 },
        });
      } else {
        const unexpectedError = 'Erro inesperado ao fazer login.';
        setError(unexpectedError);
        notification.error({
          message: 'Erro de Login',
          description: unexpectedError,
          duration: 4,
          placement: 'topRight',
          style: { zIndex: 1400 },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-page'>
      <div className='login-container'>
        <div className='login-wrapper'>
          <div className='login-form-wrapper'>
            <LoginForm
              email={email}
              password={password}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              loading={loading}
              apiResponse={error}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
